export const getNumberOfDecimals = (number: number): number => {
  const numberAsString = number.toString();

  for (let index = 0; index < numberAsString.length; index++) {
    const letter = numberAsString[index];

    if (letter === "." || letter === ",") {
      return numberAsString.length - index - 1;
    }
  }

  return -1;
};

export const hasNumbers = (string: string) => {
  const numberRegex = /.*\d.*/;

  return numberRegex.test(string);
};

export const isNumber = (number: number): boolean => {
  return !Number.isNaN(number);
};

export const isDecimalNumber = (string: string): boolean => {
  // Regular expression to check if the string is a decimal number
  var decimalNumberRegex = /^[-+]?(\d*\.\d+|\d+\.\d*[1-9])$/;

  // Test the inputString against the regex
  return decimalNumberRegex.test(string);
};

export const isWholeNumber = (string: string): boolean => {
  // Regular expression to check if the string is a whole number
  var wholeNumberRegex = /^[-+]?\d+$/;

  // Test the inputString against the regex
  return wholeNumberRegex.test(string);
};

export const convertMetersToKm = (meters: number) => {
  const km = meters / 1000;
  if (km > 10) {
    return Math.round(km);
  }
  return km.toFixed(1);
};
